import React from "react";
import mapImage from "../../../images/vector-gray-map.svg";
import { Link } from "gatsby";
import PrimaryButton from "../inputs/buttons/Button";
import { usePageSettings } from "../../../contexts/PageSettingsContext";
import { getTranslatedCityName } from "../../../utils/getTranslatedCityName";
import { constructUrl } from "../../../utils/constructUrl";
import { useAllLocations } from "../../../hooks/useFetchLocations";
import { BeatLoader } from "react-spinners";

const PresenceBanner = ({ translations }) => {
	return (
		<div className="flex flex-col lg:flex-row w-full gap-16 justify-between items-center">
			<BannerTitle translations={translations} />
			<BannerImage />
			<BannerStats translations={translations} />
		</div>
	);
};

const BannerTitle = ({ translations }) => {
	const { pageSettingsContext } = usePageSettings();
	const { country, language, city } = pageSettingsContext;
	const citySlug = getTranslatedCityName(language, city);

	return (
		<div className="flex flex-col gap-4 z-10 w-full text-ipxon-black">
			<div className="flex flex-col">
				<h4 className="text-lg text-ipxon-magenta">{translations.PresenceSectionSmallTitle}</h4>
				<h3 className="text-3xl md:text-4xl font-bold text-ipxon-black">
					{translations.PresencePlatformMainTitle1}
				</h3>
			</div>
			<p className="lg:w-[80%]">{translations.PresenceBannerText}</p>
			<PrimaryButton>
				<Link to={constructUrl(language, country, citySlug, "/presence-platform")}>
					{translations.PresenceBannerButtonText}
				</Link>
			</PrimaryButton>
		</div>
	);
};

const BannerImage = () => (
	<img
		className="invisible xl:visible bg-color-grey-500 absolute z-[-99] left-32 xl:left-64 opacity-40 -top-12 xl:-top-64 w-2/3"
		alt="IPXON Points of Presence map"
		draggable={false}
		src={mapImage}
	/>
);

const BannerStats = ({ translations }) => {
	// 1. Call your hook
	const { data: locations = [], isLoading, isError } = useAllLocations();
	const queryingLocations = isLoading || isError;

	// 2. Build stats dynamically. USe location.length to keep the PoPs synced.
	const stats = [
		{ number: "+" + locations.length, text: "PresenceBannerStatOneText" },
		{ number: translations.PresenceBannerStatTwoNumber, text: "PresenceBannerStatTwoText" },
		{ number: translations.PresenceBannerStatThreeNumber, text: "PresenceBannerStatThreeText" },
	];

	return (
		<div className="h-full flex flex-col justify-center w-full z-50">
			{queryingLocations ? (
				<p className="flex flex-col gap-1 md:gap-4 rounded-lg py-2 px-1 md:p-4 items-center w-full mb-2">
					<BeatLoader color="#d1d5db" size={8} />
				</p>
			) : (
				<ul className="flex gap-4 h-fit text-ipxon-black">
					{stats.map((stat, idx) => (
						<li
							key={idx}
							className="flex flex-col gap-1 md:gap-4 rounded-lg py-2 px-1 md:p-4 items-start w-1/3 mb-2"
						>
							<p className="font-bold text-3xl xl:text-5xl text-start">
								{/* if the translation key exists, show that; otherwise show the raw number */}
								{translations[stat.number] ?? stat.number}
							</p>
							<p className="text-xs md:text-sm md:text-start">{translations[stat.text]}</p>
						</li>
					))}
				</ul>
			)}
		</div>
	);
};

export default PresenceBanner;
